import { render, staticRenderFns } from "./directPayMainPage.vue?vue&type=template&id=6c91fafa&scoped=true"
import script from "./directPayMainPage.vue?vue&type=script&lang=js"
export * from "./directPayMainPage.vue?vue&type=script&lang=js"
import style0 from "./directPayMainPage.vue?vue&type=style&index=0&id=6c91fafa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c91fafa",
  null
  
)

export default component.exports